import styled from "styled-components";

export const SelectFieldStyled = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "isTransparent",
})`
  width: 100%;
  overflow-x: auto;
  overflow-y: clip;
  display: flex;
  flex-direction: column;

  fieldset {
    border: 1px solid #080425 !important;
  }
  .selected-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
  .selected-item {
    background-color: red;
  }
  .MuiFormControl-root {
    width: 100%;
  }
  .MuiOutlinedInput-input {
    padding: 0px !important;
    display: flex;
    align-items: center;
  }
  .label {
    margin-bottom: 8px;
    height: 23px;
  }
  .placeholder {
    color: rgba(0, 0, 0, 0.23);
    font-size: 11px;
  }
  .MuiSelect-multiple {
    padding: 0px 8px;
  }
  .MuiInputBase-root {
    width: 100%;
    height: 36px;
    background-color: ${(props) => (props.isTransparent ? "inherit" : "white")};
    padding: 6px 8px !important;
    display: flex;
    gap: 8px;
    align-items: normal;

    .chips-container {
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
      .MuiChip-root {
        border-radius: 7px;
        height: 27px;
        background-color: #dedafb;
      }
      span {
        font-size: 12px;
        color: #301d35;
      }
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
      padding: 6.5px 11px;
    }
    input {
      z-index: 1;
    }
    &.Mui-disabled {
      cursor: default;
      /* background: rgba(235, 238, 245, 0.2); */
      opacity: 0.8 !important;
    }
  }

  .Mui-disabled {
    -webkit-text-fill-color: #b9bec7 !important;
  }
`;
